import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useProfile } from '../../../../context/profile/ProfileContext';
import BillingCycleModal from './sections/BillingCycleModal';
import PaymentMethodModal from './sections/PaymentMethodModal';
import CancelSubscriptionModal from './sections/CancelSubscriptionModal';
import DowngradeModal from './sections/DowngradeModal';
import SwitchMonthlyModal from './sections/SwitchMonthlyModal';
import UpgradePlanModal from './sections/UpgradePlanModal';
import AnnualSupportModal from './sections/AnnualSupportModal';
import CheckoutDirectModal from './sections/CheckoutDirectModal';

const ProfileModals = () => {
  const {
    showCycModal,
    showPmModal,
    showCancelModal,
    showDowngradeModal,
    showSwitchMonthlyModal,
    showUpgradeModal,
    showAnnualSupportModal,
    showCheckoutPage
  } = useProfile();

  const isAnyModalOpen = Boolean(
    showCycModal ||
    showPmModal ||
    showCancelModal ||
    showDowngradeModal ||
    showSwitchMonthlyModal ||
    showUpgradeModal ||
    showAnnualSupportModal ||
    showCheckoutPage
  );

  useEffect(() => {
    if (isAnyModalOpen) {
      const originalBodyOverflow = document.body.style.overflow;
      const originalHtmlOverflow = document.documentElement.style.overflow;
      const mainEl = document.querySelector('main');
      const originalMainOverflow = mainEl ? mainEl.style.overflow : '';

      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      if (mainEl) {
        mainEl.style.overflow = 'hidden';
      }

      return () => {
        document.body.style.overflow = originalBodyOverflow;
        document.documentElement.style.overflow = originalHtmlOverflow;
        if (mainEl) {
          mainEl.style.overflow = originalMainOverflow;
        }
      };
    }
  }, [isAnyModalOpen]);

  if (!isAnyModalOpen || typeof document === 'undefined') return null;

  return createPortal(
    <>
      {/* 1. Switch to Annual Billing Modal */}
      <BillingCycleModal />

      {/* 2. Update Payment Method Modal */}
      <PaymentMethodModal />

      {/* 3. Cancel Subscription Modal */}
      <CancelSubscriptionModal />

      {/* 4. Downgrade Plan Modal */}
      <DowngradeModal />

      {/* 5. Switch to Monthly Modal */}
      <SwitchMonthlyModal />

      {/* 6. Mid-Cycle Upgrade Modal */}
      <UpgradePlanModal />

      {/* 7. Annual Plan Support Modal */}
      <AnnualSupportModal />

      {/* 8. Dedicated Mandate Checkout Modal */}
      <CheckoutDirectModal />

      <style dangerouslySetInnerHTML={{
        __html: `
        @keyframes modal-entry {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
        .animate-modal-entry {
          animation: modal-entry 0.25s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      ` }} />
    </>,
    document.body
  );
};

export default ProfileModals;
